import { Model } from '@/models/Model';
import { RolesEnum } from '@/items/Roles';
export class Group extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Group';
        this.$endpoint = '/groups';
        this.$fillable = [
            'name',
            'type',
            'users',
            'room',
            'is_mandatory',
            'project',
            'sub_groups',
        ];
    }
    async restoreGroup() {
        return await this.request('get', `${this.$endpoint}/restore?group=${this.id}`);
    }
    getStudents() {
        if (!this.users || this.users.length === 0) {
            return [];
        }
        return this.users.filter((user) => user.roles && user.roles.some((role) => role.name.toLowerCase() === RolesEnum.STUDENT));
    }
}
